import { ActionTypes, CheckoutsStripeAccountFetchAction, CheckoutsStripeAccountFetchErrorAction, CheckoutsStripeAccountFetchSuccessAction, CheckoutsStripeAccountState, CheckoutsStripeAccountUpdateAction, CheckoutsStripeAccountUpdateErrorAction, CheckoutsStripeAccountUpdateSuccessAction  } from './types';
import { ApplicationState } from '..';


export const CheckoutsStripeAccountFetch = (): CheckoutsStripeAccountFetchAction => ({
    type: ActionTypes.FETCH_START
});
export const CheckoutsStripeAccountFetchSuccess = (checkoutsStripeAccount): CheckoutsStripeAccountFetchSuccessAction => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: {
        checkoutsStripeAccount
    },
});
export const CheckoutsStripeAccountFetchError = (): CheckoutsStripeAccountFetchErrorAction => ({
    type: ActionTypes.FETCH_ERROR,
});

export const CheckoutsStripeAccountUpdate = (ReturnUrl: string, RefreshUrl?: string): CheckoutsStripeAccountUpdateAction => ({
    type: ActionTypes.UPDATE_START,
    payload: {
        ReturnUrl,
        RefreshUrl
    },
    meta: {
        thunk: true,
    },
});
export const CheckoutsStripeAccountUpdateSuccess = (meta: Record<string, any>): CheckoutsStripeAccountUpdateSuccessAction => ({
    type: ActionTypes.UPDATE_SUCCESS,
    payload: null,
    meta
});
export const CheckoutsStripeAccountUpdateError = (meta: Record<string, any>): CheckoutsStripeAccountUpdateErrorAction => ({
    type: ActionTypes.UPDATE_ERROR,
    error: true,
    meta
});

export const getCheckoutsStripeAccountStore = (store: ApplicationState): CheckoutsStripeAccountState => store.checkoutsStripeAccount || {} as CheckoutsStripeAccountState;
